module.exports = __webpack_public_path__ + "09_hair_gold.7675b8a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/09_hair_gold.png
// module id = NAgV
// module chunks = 0